var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('legend', [_vm._v("Mark Bag Shortage")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.listLoading
    },
    on: {
      "update:active": function($event) {
        _vm.listLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag Nos (Max 50) :")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('bagNo')
    },
    attrs: {
      "type": "text",
      "rows": "5",
      "max-rows": "5",
      "placeholder": "Enter Bag Nos , Use comma for multiple Bag Nos",
      "name": "bagNo",
      "id": "bagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bagNoError),
      expression: "bagNoError"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoError))]), _vm._v(" "), (_vm.bagLimit) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagLimitMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBulkBagDetailsByBagnos
    }
  }, [_vm._v(" Show")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.markshortLoading
    },
    on: {
      "update:active": function($event) {
        _vm.markshortLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ("" + ((_vm.shortagebaglist.length>0) ? 'showdest' : '')),
    staticStyle: {
      "overflow-x": "auto",
      "margin-top": "1%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader",
    attrs: {
      "colspan": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllbags),
      expression: "checkAllbags"
    }],
    staticStyle: {
      "margin-left": "0.5%",
      "cursor": "pointer"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllbags) ? _vm._i(_vm.checkAllbags, null) > -1 : (_vm.checkAllbags)
    },
    on: {
      "click": _vm.checkBag,
      "change": function($event) {
        var $$a = _vm.checkAllbags,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllbags = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllbags = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllbags = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "all"
    }
  }, [_vm._v(" Select All      ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin-left": "53%",
      "font-weight": "600"
    }
  }, [_vm._v("Eligible Bags: " + _vm._s(this.EligibleBagCount) + "     Non Eligible Bags:" + _vm._s(this.NonEligibleBagCount))]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "3%",
      "width": "100px",
      "height": "35px"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.addmodalShow()
      }
    }
  }, [_vm._v("Mark Short")])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Outscanned From")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Outscanned For")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Trip ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Time after vehicle iscannned (in hrs)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.shortagebaglist), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "0.5%"
      },
      attrs: {
        "type": "checkbox",
        "id": data.bagno,
        "disabled": !(data.allowshortage)
      },
      domProps: {
        "checked": _vm.checked[data.bagno]
      },
      on: {
        "change": _vm.updateselected
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocationname) + " " + _vm._s(data.processlocation ? '(' + data.processlocation + ')' : ''))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.inscantouchpointhubname) + " " + _vm._s((data.inscantouchpointhubid) ? '(' + data.inscantouchpointhubid + ')' : ''))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.tripid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.timeaftervehicleinscan))]), _vm._v(" "), (data.allowshortage) ? _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn-primary",
      on: {
        "click": function($event) {
          return _vm.addmodalShow(data)
        }
      }
    }, [_vm._v("Mark Short")])]) : _vm._e(), _vm._v(" "), (!data.allowshortage) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Remark))]) : _vm._e()])
  }), _vm._v(" "), (_vm.shortagebaglist.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.addmodalShowflag),
      callback: function($$v) {
        _vm.addmodalShowflag = $$v
      },
      expression: "addmodalShowflag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.bulkBagArr.length > 0) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.bulkBagArr.length) + " bags will be marked short. "), _c('br'), _vm._v(" Please confirm?")])]) : _vm._e(), _vm._v(" "), (this.selected.bagno) ? _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to mark " + _vm._s(this.selected.bagno) + " bag shortage?")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShowflag = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("No")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fd49a71","hasScoped":true}!./src/views/components/MarkBulkBagShortage/MarkBulkBagShortage.html
// module id = 1963
// module chunks = 2